
// import React, { useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Button,
//   Box,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   CssBaseline,
//   Container,
//   Paper,
//   createTheme,
//   ThemeProvider,
//   Grid,
//   useMediaQuery,
// } from "@mui/material";
// import {
//   FaQrcode,
//   FaChartLine,
//   FaSearch,
//   FaLink,
//   FaFilePdf,
//   FaList,
//   FaFile,
//   FaAddressBook,
//   FaShareAlt,
//   FaUser,
//   FaBars,
// } from "react-icons/fa";

// // Sidebar Items
// const sidebarItems = [
//   { text: "Generate QR", icon: <FaQrcode /> },
//   { text: "My QR Codes", icon: <FaChartLine /> },
//   { text: "Profile", icon: <FaUser /> },
// ];

// // Button Options
// const buttonOptions = [
//   { key: "url", label: "URL", icon: <FaLink /> },
//   { key: "pdf", label: "PDF", icon: <FaFilePdf /> },
//   { key: "multiurl", label: "Multi-URL", icon: <FaList /> },
//   { key: "file", label: "File", icon: <FaFile /> },
//   { key: "visiting", label: "Visiting Card", icon: <FaAddressBook /> },
//   { key: "images", label: "Images", icon: <FaFile /> },
//   { key: "videos", label: "Videos", icon: <FaFile /> },
//   { key: "location", label: "Location", icon: <FaFile /> },
//   { key: "app", label: "App", icon: <FaFile /> },
// ];




// const Dashboard = () => {
//   const [sidebarExpanded, setSidebarExpanded] = useState(true); // Sidebar expand/collapse toggle
//   const [mobileOpen, setMobileOpen] = useState(false); // Mobile Sidebar toggle
//   const [selectedOption, setSelectedOption] = useState("url"); // State for selected button
//   const [inputValue, setInputValue] = useState(""); // Input value

//   const isMobile = useMediaQuery("(max-width:600px)");

//   const toggleSidebar = () => {
//     setSidebarExpanded(!sidebarExpanded); // Toggle expanded/collapsed sidebar
//   };

//   const handleMobileDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const theme = createTheme({
//     palette: {
//       primary: {
//         main: "#1976d2",
//       },
//       secondary: {
//         main: "#ff4081",
//       },
//       background: {
//         default: "#f4f4f4",
//       },
//     },
//   });

//   const drawer=(
//     <Box
//   sx={{
//     width: isMobile ? 250 : sidebarExpanded ? 250 : 80,
//     overflow: "hidden",
//     transition: "width 0.3s ease",
//     bgcolor: "#1E293B", // Dark blue background for the sidebar
//     color: "#FFFFFF", // White text color
//     height: "100vh", // Full height
//     display: "flex",
//     flexDirection: "column",
//   }}
// >
//   {/* Sidebar Header */}
//   <Box
//     sx={{
//       display: "flex",
//       alignItems: "center",
//       justifyContent: sidebarExpanded ? "space-between" : "center",
//       padding: "10px",
//       bgcolor: "#0F172A", // Slightly darker header background
//     }}
//   >
//     {sidebarExpanded && (
//       <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//         THE QR CODE
//       </Typography>
//     )}
//     {!isMobile && (
//         <IconButton onClick={toggleSidebar} sx={{ color: "#FFFFFF" }}>
//           <FaBars />
//         </IconButton>
//       )}
//   </Box>

//   {/* Divider */}
//   <Divider sx={{ bgcolor: "#334155" }} />

//   {/* Sidebar List */}
//   <List>
//   {sidebarItems.map((item, index) => (
//     <ListItem
//       button
//       key={index}
//       sx={{
//         justifyContent: isMobile || sidebarExpanded ? "flex-start" : "center", // Full text for mobile or expanded sidebar, only icon for collapsed sidebar on large screens
//         paddingY: "10px",
//         paddingX: sidebarExpanded || isMobile ? "16px" : "10px", // Full padding for mobile/expanded, smaller padding for collapsed
//         margin: "5px 10px",
//         borderRadius: "8px",
//         "&:hover": {
//           bgcolor: "#475569", // Hover color
//           color: "#FFFFFF",
//         },
//         transition: "background-color 0.3s ease",
//       }}
//     >
//       <ListItemIcon
//         sx={{
//           color: "#FFFFFF",
//           minWidth: "40px", // Fixed width for icons
//         }}
//       >
//         {item.icon}
//       </ListItemIcon>
//       {(isMobile || sidebarExpanded) && (  // Show full text for mobile and expanded sidebar
//         <ListItemText
//           primary={item.text}
//           sx={{
//             fontWeight: "500",
//           }}
//         />
//       )}
//     </ListItem>
//   ))}
// </List>


//   {/* Footer Section (Optional) */}
//   <Box
//     sx={{
//       marginTop: "auto",
//       padding: "10px",
//       textAlign: "center",
//       bgcolor: "#0F172A",
//     }}
//   >
//     <Typography variant="caption" sx={{ fontSize: "12px" }}>
//       © 2024 QR Code Generator
//     </Typography>
//   </Box>
// </Box>

// )


//   const handleButtonClick = (option) => {
//     setSelectedOption(option);
//     setInputValue(""); // Reset input field
//   };

//   const renderInputField = () => {
//     switch (selectedOption) {
//       case "url":
//         return (
//           <>
//             <Typography variant="body1">Enter a URL:</Typography>
//             <input
//               type="text"
//               placeholder="https://example.com"
//               value={inputValue}
//               onChange={(e) => setInputValue(e.target.value)}
//               style={inputStyle}
//             />
//           </>
//         );
//       case "pdf":
//         return (
//           <>
//             <Typography variant="body1">Upload a PDF:</Typography>
//             <input
//               type="file"
//               accept=".pdf"
//               onChange={(e) => setInputValue(e.target.files[0]?.name || "")}
//               style={inputStyle}
//             />
//           </>
//         );
//       case "file":
//         return (
//           <>
//             <Typography variant="body1">Upload a File:</Typography>
//             <input
//               type="file"
//               onChange={(e) => setInputValue(e.target.files[0]?.name || "")}
//               style={inputStyle}
//             />
//           </>
//         );
//       case "images":
//         return (
//           <>
//             <Typography variant="body1">Upload an Image:</Typography>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) => setInputValue(e.target.files[0]?.name || "")}
//               style={inputStyle}
//             />
//           </>
//         );
//       case "videos":
//         return (
//           <>
//             <Typography variant="body1">Upload a Video:</Typography>
//             <input
//               type="file"
//               accept="video/*"
//               onChange={(e) => setInputValue(e.target.files[0]?.name || "")}
//               style={inputStyle}
//             />
//           </>
//         );
//       case "location":
//         return (
//           <>
//             <Typography variant="body1">Enter a Location URL:</Typography>
//             <input
//               type="text"
//               placeholder="https://maps.google.com"
//               value={inputValue}
//               onChange={(e) => setInputValue(e.target.value)}
//               style={inputStyle}
//             />
//           </>
//         );
//       default:
//         return <Typography variant="body1">Please select an option</Typography>;
//     }
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ display: "flex" }}>
//         <CssBaseline />

//         {/* AppBar */}
//         <AppBar
//           position="fixed"
//           sx={{
//             width: isMobile ? "100%" : sidebarExpanded ? "80%" : "93%",
//             flexShrink: 0,
//             transition: "width 0.3s ease",
//           }}
//         >
//           <Toolbar>
//             {isMobile && (
//               <IconButton
//                 color="inherit"
//                 edge="start"
//                 onClick={handleMobileDrawerToggle}
//                 sx={{ mr: 2 }}
//               >
//                 <FaBars />
//               </IconButton>
//             )}
//             <Typography variant="h6" sx={{ flexGrow: 1 }}>
//               THE QR CODE GENERATOR
//             </Typography>
//             <Button color="inherit">
//               <FaUser />
//             </Button>
//           </Toolbar>
//         </AppBar>
//         <Box
//           component="nav"
//           sx={{
//             width: sidebarExpanded ? 250 : 80,
//             flexShrink: 0,
//             transition: "width 0.3s ease",
//           }}
//         >
//           {/* Mobile Sidebar */}
//           <Drawer
//             variant="temporary"
//             open={mobileOpen}
//             onClose={handleMobileDrawerToggle}
//             ModalProps={{
//               keepMounted: true,
//             }}
//             sx={{
//               display: { xs: "block", sm: "none" },
//               "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
//             }}
//           >
//             {drawer}
//           </Drawer>

//           {/* Desktop Sidebar */}
//           <Drawer
//             variant="permanent"
//             sx={{
//               display: { xs: "none", sm: "block" },
//               "& .MuiDrawer-paper": {
//                 boxSizing: "border-box",
//                 width: sidebarExpanded ? 250 : 80,
//                 transition: "width 0.3s ease",
//               },
//             }}
//             open
//           >
//             {drawer}
//           </Drawer>
//         </Box>





//         {/* Main Content */}
//         <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
//           <Toolbar />
//           <Container>
//             {/* Buttons */}
//             <Grid container spacing={2}>
//               {buttonOptions.map((btn) => (
//                 <Grid item xs={12} sm={6} md={3} key={btn.key}>
//                   <Button
//                     variant={
//                       selectedOption === btn.key ? "contained" : "outlined"
//                     }
//                     fullWidth
//                     onClick={() => handleButtonClick(btn.key)}
//                   >
//                     {btn.icon} {btn.label}
//                   </Button>
//                 </Grid>
//               ))}
//             </Grid>

//             {/* Dynamic Input Field */}
//             <Box sx={{ marginTop: 4 }}>{renderInputField()}</Box>

//             {/* Next Button */}
//             <Box sx={{ marginTop: 4, textAlign: "right" }}>
//               <Button variant="contained" color="primary">
//                 Next
//               </Button>
//             </Box>
//           </Container>
//         </Box>
//       </Box>
//     </ThemeProvider>
//   );
// };

// // Input Field Style
// const inputStyle = {
//   width: "100%",
//   padding: "10px",
//   borderRadius: "4px",
//   border: "1px solid #ccc",
//   marginTop: "10px",
// };

// export default Dashboard;


// import React, { useState } from "react";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Button,
//   Box,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   CssBaseline,
//   Container,
//   Grid,
//   useMediaQuery,
// } from "@mui/material";
// import { FaBars, FaUser } from "react-icons/fa";
// import QRCodeGenerator from "../QRCode/QrGenerator";

// // Sidebar Items
// const sidebarItems = [
//   { text: "Generate QR", icon: <FaBars /> },
//   { text: "My QR Codes", icon: <FaBars /> },
//   { text: "Profile", icon: <FaUser /> },
// ];

// // Button Options
// const buttonOptions = [
//   { key: "url", label: "URL", icon: <FaBars /> },
//   { key: "pdf", label: "PDF", icon: <FaBars /> },
//   { key: "file", label: "File", icon: <FaBars /> },
//   { key: "images", label: "Images", icon: <FaBars /> },
//   { key: "videos", label: "Videos", icon: <FaBars /> },
//   { key: "location", label: "Location", icon: <FaBars /> },
// ];

// // QR Code Generator Component


// const Dashboard = () => {
//   const [sidebarExpanded, setSidebarExpanded] = useState(true);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState("url");
//   const [inputValue, setInputValue] = useState(""); // Input value for QR Code
//   const [showQRGenerator, setShowQRGenerator] = useState(false);

//   const isMobile = useMediaQuery("(max-width:600px)");

//   const toggleSidebar = () => {
//     setSidebarExpanded(!sidebarExpanded);
//   };

//   const handleMobileDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handleButtonClick = (option) => {
//     setSelectedOption(option);
//     setInputValue(""); // Reset input field
//     setShowQRGenerator(false); // Reset QR generator view
//   };

//   const handleNextButtonClick = () => {
//     if (inputValue) {
//       setShowQRGenerator(true);
//     }
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />
//       <AppBar position="fixed">
//         <Toolbar>
//           {isMobile && (
//             <IconButton
//               color="inherit"
//               edge="start"
//               onClick={handleMobileDrawerToggle}
//               sx={{ mr: 2 }}
//             >
//               <FaBars />
//             </IconButton>
//           )}
//           <Typography variant="h6" sx={{ flexGrow: 1 }}>
//             THE QR CODE GENERATOR
//           </Typography>
//           <Button color="inherit">
//             <FaUser />
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar */}
//       <Box component="nav">
//         {/* Sidebar Drawer for mobile */}
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleMobileDrawerToggle}
//           ModalProps={{
//             keepMounted: true,
//           }}
//         >
//           {/* Add Sidebar Items Here */}
//         </Drawer>

//         {/* Sidebar for Desktop */}
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//           }}
//           open
//         >
//           {/* Add Sidebar Items Here */}
//         </Drawer>
//       </Box>

//       {/* Main Content */}
//       <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
//         <Container>
//           {/* Buttons */}
//           {!showQRGenerator ? (
//             <Grid container spacing={2}>
//               {buttonOptions.map((btn) => (
//                 <Grid item xs={12} sm={6} md={3} key={btn.key}>
//                   <Button
//                     variant={selectedOption === btn.key ? "contained" : "outlined"}
//                     fullWidth
//                     onClick={() => handleButtonClick(btn.key)}
//                   >
//                     {btn.icon} {btn.label}
//                   </Button>
//                 </Grid>
//               ))}
//             </Grid>
//           ) : (
//             <QRCodeGenerator inputValue={inputValue} />
//           )}

//           {/* Input Field */}
//           {!showQRGenerator && (
//             <Box sx={{ marginTop: 4 }}>
//               <Typography variant="body1">Enter a Value:</Typography>
//               <input
//                 type="text"
//                 value={inputValue}
//                 onChange={(e) => setInputValue(e.target.value)}
//                 placeholder="Enter your value"
//                 style={{ width: "100%", padding: "10px" }}
//               />
//             </Box>
//           )}

//           {/* Next Button */}
//           {!showQRGenerator && (
//             <Box sx={{ marginTop: 4, textAlign: "right" }}>
//               <Button variant="contained" color="primary" onClick={handleNextButtonClick}>
//                 Next
//               </Button>
//             </Box>
//           )}
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Dashboard;



import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  CssBaseline,
  Container,
  Paper,
  createTheme,
  ThemeProvider,
  Grid,
  useMediaQuery,
  Menu,
   MenuItem
} from "@mui/material";
import {
  FaQrcode,
  FaChartLine,
  FaSearch,
  FaLink,
  FaFilePdf,
  FaList,
  FaFile,
  FaAddressBook,
  FaShareAlt,
  FaUser,
  FaBars,
  FaImage,
  FaVideo,
  FaMapMarkerAlt,
  FaVolumeUp,
  FaCloudUploadAlt,
  FaChartBar,
  FaEnvelope,
  FaRegAddressBook,
  FaSms,
  FaPhone,
} from "react-icons/fa";
import QRCodeGenerator from "../QRCode/QrGenerator";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import QRCodeTable from "../FileTable/FileTable";
import qrgenious from '../images/qrgenious.png'
import Profile from "../Profile/Profile";
import BulkUpload from "../BulkUpload/BulkUpload";
import AnalyticsDashboard from "../Analytics/Analytics";

// Sidebar Items
const sidebarItems = [
  { text: "Generate QR", icon: <FaQrcode /> },
  { text: "My QR Codes", icon: <FaChartLine /> },
  { text: "Profile", icon: <FaUser /> },
  { text: "Bulk Upload", icon: <FaCloudUploadAlt /> },
  {text:'Analytics', icon: <FaChartBar />}
];
 // Track selected sidebar item


// Button Options
const buttonOptions = [
  { key: "url", label: "URL", icon: <FaLink /> },
  { key: "pdf", label: "PDF", icon: <FaFilePdf /> },
 
  { key: "file", label: "File", icon: <FaFile /> },

  { key: "images", label: "Images", icon: <FaImage /> },
  { key: "audio", label: "Audio", icon: <FaVolumeUp /> },
  { key: "videos", label: "Videos", icon: <FaVideo /> },
  { key: "location", label: "Location", icon: <FaMapMarkerAlt /> },
  { key: "email", label: "Email", icon: <FaEnvelope /> },
  { key: "contact", label: "Contact", icon: <FaRegAddressBook /> },
  { key: "sms", label: "SMS", icon: <FaSms /> }, 
  { key: "phone", label: "Phone", icon: <FaPhone /> },


];



const Dashboard = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true); // Sidebar expand/collapse toggle
  const [mobileOpen, setMobileOpen] = useState(false); // Mobile Sidebar toggle
  const [selectedOption, setSelectedOption] = useState("url"); // State for selected button
const [inputValue, setInputValue] = useState("");
 // Input value
  const [isQrGenerated, setIsQrGenerated] = useState(false); // State to track QR generation
  const [qrInput, setQrInput] = useState("");
  
const [selectedSidebarItem, setSelectedSidebarItem] = useState("Generate QR"); // Input for QR code generation

  const isMobile = useMediaQuery("(max-width:600px)");

  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded); // Toggle expanded/collapsed sidebar
  };



  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };


  const theme = createTheme({
    palette: {
      primary: {
        main: "#1976d2",
      },
      secondary: {
        main: "#ff4081",
      },
      background: {
        default: "#f4f4f4",
      },
    },
  });

  // const drawer = (
  //   <Box
  //     sx={{
  //       width: isMobile ? 250 : sidebarExpanded ? 250 : 80,
  //       overflow: "hidden",
  //       transition: "width 0.3s ease",
  //       bgcolor: "#1E293B", // Dark blue background for the sidebar
  //       color: "#FFFFFF", // White text color
  //       height: "100vh", // Full height
  //       display: "flex",
  //       flexDirection: "column",
  //     }}
  //   >
  //     {/* Sidebar Header */}
  //     <Box
  //       sx={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: sidebarExpanded ? "space-between" : "center",
  //         padding: "10px",
  //         bgcolor: "#0F172A", // Slightly darker header background
  //       }}
  //     >
  //       {sidebarExpanded && (
  //         <Typography variant="h6" sx={{ fontWeight: "bold" }}>
  //           THE QR CODE
  //         </Typography>
  //       )}
  //       {!isMobile && (
  //         <IconButton onClick={toggleSidebar} sx={{ color: "#FFFFFF" }}>
  //           <FaBars />
  //         </IconButton>
  //       )}
  //     </Box>

  //     {/* Divider */}
  //     <Divider sx={{ bgcolor: "#334155" }} />

  //     {/* Sidebar List */}
  //     <List>
  //       {sidebarItems.map((item, index) => (
  //         <ListItem
  //           button
  //           key={index}
  //           onClick={() => handleSidebarItemClick(item.text)}
  //           sx={{
  //             justifyContent: isMobile || sidebarExpanded ? "flex-start" : "center", // Full text for mobile or expanded sidebar, only icon for collapsed sidebar on large screens
  //             paddingY: "10px",
  //             paddingX: sidebarExpanded || isMobile ? "16px" : "10px", // Full padding for mobile/expanded, smaller padding for collapsed
  //             margin: "5px 10px",
  //             borderRadius: "8px",
  //             "&:hover": {
  //               bgcolor: "#475569", // Hover color
  //               color: "#FFFFFF",
  //             },
  //             transition: "background-color 0.3s ease",
  //           }}
  //         >
  //           <ListItemIcon
  //             sx={{
  //               color: "#FFFFFF",
  //               minWidth: "40px", // Fixed width for icons
  //             }}
  //           >
  //             {item.icon}
  //           </ListItemIcon>
  //           {(isMobile || sidebarExpanded) && (  // Show full text for mobile and expanded sidebar
  //             <ListItemText
  //               primary={item.text}
  //               sx={{
  //                 fontWeight: "500",
  //               }}
  //             />
  //           )}
  //         </ListItem>
  //       ))}
  //     </List>

  //     {/* Footer Section (Optional) */}
  //     <Box
  //       sx={{
  //         marginTop: "auto",
  //         padding: "10px",
  //         textAlign: "center",
  //         bgcolor: "#0F172A",
  //       }}
  //     >
  //       <Typography variant="caption" sx={{ fontSize: "12px" }}>
  //         © 2024 QR Code Generator
  //       </Typography>
  //     </Box>
  //   </Box>
  // );


  const drawer = (
    <Box
      sx={{
        width: isMobile ? 250 : sidebarExpanded ? 250 : 80,
        overflow: "hidden",
        transition: "width 0.3s ease",
        bgcolor: "#1E293B", // Dark blue background for the sidebar
        color: "#FFFFFF", // White text color
        height: "100%", // Full height
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Sidebar Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: sidebarExpanded ? "space-between" : "center",
          padding: "10px",
          bgcolor: "#0F172A", // Slightly darker header background
        }}
      >
        {sidebarExpanded && (
          <>
            {/* Logo */}
            <img src={qrgenious} alt="QR Genious Logo" style={{ height: "40px", marginRight: "10px" }} />
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            QR GENIOUS 
            </Typography>
          </>
        )}
        {!isMobile && (
          <IconButton onClick={toggleSidebar} sx={{ color: "#FFFFFF" }}>
            <FaBars />
          </IconButton>
        )}
      </Box>
  
      {/* Divider */}
      <Divider sx={{ bgcolor: "#334155" }} />
  
      {/* Sidebar List */}
      <List>
        {sidebarItems.map((item, index) => (
          <ListItem
            button
            key={index}
            onClick={() => handleSidebarItemClick(item.text)}
            sx={{
              justifyContent: isMobile || sidebarExpanded ? "flex-start" : "center", // Full text for mobile or expanded sidebar, only icon for collapsed sidebar on large screens
              paddingY: "10px",
              paddingX: sidebarExpanded || isMobile ? "16px" : "10px", // Full padding for mobile/expanded, smaller padding for collapsed
              margin: "5px 10px",
              borderRadius: "8px",
              "&:hover": {
                bgcolor: "#475569", // Hover color
                color: "#FFFFFF",
              },
              transition: "background-color 0.3s ease",
            }}
          >
            <ListItemIcon
              sx={{
                color: "#FFFFFF",
                minWidth: "40px", // Fixed width for icons
              }}
            >
              {item.icon}
            </ListItemIcon>
            {(isMobile || sidebarExpanded) && (  // Show full text for mobile and expanded sidebar
              <ListItemText
                primary={item.text}
                sx={{
                  fontWeight: "500",
                }}
              />
            )}
          </ListItem>
        ))}
      </List>
  
      {/* Footer Section (Optional) */}
      <Box
        sx={{
          marginTop: "auto",
          padding: "10px",
          textAlign: "center",
          bgcolor: "#0F172A",
        }}
      >
        <Typography variant="caption" sx={{ fontSize: "12px" }}>
          © 2025  QR GENIOUS QR CODE Generator
        </Typography>
      </Box>
    </Box>
  );

//26-05-2026


const handleButtonClick = (option) => {
  setSelectedOption(option);
  setInputValue({
  
  }); // ✅ Correct shape
  setIsQrGenerated(false);
};


  // const handleButtonClick = (option) => {
  //   setSelectedOption(option);
  //   setInputValue(""); // Reset input field
  //   setIsQrGenerated(false); // Reset QR generation
  // };

  // const handleNextClick = () => {
  //   // Check if the input is valid
  //   if (inputValue.trim()) {
  //     setQrInput(inputValue);
  //     handleFileUpload(inputValue)
  //     setIsQrGenerated(true); // Trigger QR generation
  //   } else {
  //     alert("Please enter a valid input.");
  //   }
  // };

  const  userId =sessionStorage.getItem('userId')


  // const handleFileUpload = async (file) => {
  //   if (!file) {
  //     console.error("No file selected.");
  //     alert("Please select a file to upload.");
  //     return;
  //   }
  //   const formData = new FormData();
  //   formData.append('file', file);
  //   formData.append('userId',userId)
  
  //   try {
  //     const response = await axios.post("https://qrapi.emedha.in/upload", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     if (response.data.filePath) {
  //       console.log(response.data.filePath);
  //     }
  //   } catch (err) {
  //     console.error("Error uploading file:", err);
  //     alert("Error uploading file.");
  //   }
  // };
  
  
  // Handle the next button click
 
  const handleFileUpload = async (file) => {
    if (!file) {
      console.error("No file selected.");
      alert("Please select a file to upload.");
      return;
    }
  
    if (file instanceof File) {
      // Handle file upload
      const formData = new FormData();
      formData.append('file', file);
      formData.append('userId', userId);
  
      try {
        const response = await axios.post("https://qrapi.emedha.in/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.filePath) {
          console.log(response.data.filePath);
          setQrInput(response.data.filePath); // Use the uploaded file's path for QR generation
          setIsQrGenerated(true);
        }
      } catch (err) {
        console.error("Error uploading file:", err);
        alert("Error uploading file.");
      }
    } else {
      // Handle text input
      try {
        const response = await axios.post("https://qrapi.emedha.in/process-text", {
          text: file,
          userId: userId,
        });
  
        if (response.data.processedText) {
          console.log(response.data.processedText);
          setQrInput(response.data.processedText); // Use processed text for QR generation
          setIsQrGenerated(true);
        }
      } catch (err) {
        console.error("Error processing text:", err);
        alert("Error processing text.");
      }
    }
  };
 
 
 
  const handleNextClick = (inputValue) => {
    // Check if inputValue is a File object

    if (selectedOption === "phone") {
  const { phone } = inputValue || {};
  if (!phone) {
    alert("Please enter a phone number.");
    return;
  }

  const telLink = `tel:${phone}`;
  setQrInput(telLink);
  setIsQrGenerated(true);
  return;
}


    if (selectedOption === "sms") {
  const { phone, message } = inputValue || {};
  if (!phone) {
    alert("Please enter a phone number.");
    return;
  }

  // Some phones need ?body=, others need &body= depending on the platform
  const smsLink = `sms:${phone}?body=${encodeURIComponent(message || "")}`;

  setQrInput(smsLink);
  setIsQrGenerated(true);
  return;
}


    if (selectedOption === "contact") {
  const {
    firstName = "",
    lastName = "",
    prefix = "",
    organization = "",
    jobTitle = "",
    email = "",
    phone = "",
    mobilePhone = "",
    fax = "",
    street = "",
    city = "",
    region = "",
    postcode = "",
    country = "",
    url = "",
  } = inputValue;

  const vCard = `
BEGIN:VCARD
VERSION:3.0
N:${lastName};${firstName}
FN:${prefix} ${firstName} ${lastName}
ORG:${organization}
TITLE:${jobTitle}
EMAIL:${email}
TEL;TYPE=WORK,VOICE:${phone}
TEL;TYPE=CELL,VOICE:${mobilePhone}
TEL;TYPE=FAX:${fax}
ADR;TYPE=WORK:;;${street};${city};${region};${postcode};${country}
URL:${url}
END:VCARD
  `.trim();

  setQrInput(vCard);
  setIsQrGenerated(true);
  return;
}


      if (selectedOption === "email") {
    const { email, subject, body } = inputValue || {};
    if (!email) {
      alert("Please enter an email address.");
      return;
    }

    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(body || "")}`;
    setQrInput(mailtoLink);
    setIsQrGenerated(true);
    return;
  }

    if (inputValue instanceof File) {
      // Handle file upload if inputValue is a file
      handleFileUpload(inputValue);
      // setQrInput(inputValue);  // Set the URL for QR generation
          setIsQrGenerated(true); // Pass the File object directly for upload
    } else {
      const trimmedInput = inputValue ? String(inputValue).trim() : ""; // Ensure inputValue is a string before trimming
      
      if (trimmedInput) {
        console.log(trimmedInput); // Log the trimmed input
        
        // Check if the input is a URL or a file path (image, pdf, video, etc.)
        if (isFile(trimmedInput)) {
          // If the input is a file URL, trigger file upload or download
          handleFileUpload(trimmedInput);
           // Upload or process the file as needed
        } else {
          handleFileUpload(trimmedInput);
          // Otherwise, treat it as a URL (web URL, location, etc.)
          // setQrInput(trimmedInput);  // Set the URL for QR generation
          setIsQrGenerated(true);    // Trigger QR generation if it's a valid URL
        }
      } else {
        alert("Please enter a valid input.");
      }
    }
  };
  
  
  
  // Helper function to determine if the input is a file URL
  const isFile = (input) => {
    const fileExtensions = ["jpg", "jpeg", "png", "gif", "pdf", "mp4", "mp3", "wav"];
    const urlExtension = input.split('.').pop().toLowerCase();
  
    return fileExtensions.includes(urlExtension);
  };
  





//   const RenderInputField = () => {
//      const inputRef = useRef(null);
//      const emailRef = useRef(null);
//      const subjectRef = useRef(null);
//      const bodyRef = useRef(null);
  
//      const handleChange = (e, field) => {
//   console.log("e,field" , e ,field)
//   const { value } = e.target;
//     console.log("value" , value)
//   if (inputValue[field] !== value) {
//     setInputValue((prev) => ({ ...prev, [field]: value }));
//   }
// };


//     // Focus the input field when the selected option changes
//    const hasFocusedRef = useRef(false);

// useEffect(() => {
//   if (!hasFocusedRef.current) {
//     hasFocusedRef.current = true;
//     if (selectedOption === "email") {
//       emailRef.current?.focus();
//     } else {
//       inputRef.current?.focus();
//     }
//   }
// }, [selectedOption]);


  
//     // Handle file changes based on selected option
//     const handleFileChange = (e, type) => {
//       const file = e.target.files[0];
//       if (file) {
//         // Check file size (in bytes), 5MB = 5 * 1024 * 1024 = 5242880 bytes
//         const maxFileSize = 50 * 1024 * 1024;
  
//         if (file.size > maxFileSize) {
//           alert(`The selected file is too large. Please select a file smaller than 50MB.`);
//         } else {
//           setInputValue(file); // Set file if it's within size limit
//         }
//       }
//     };
  
//     switch (selectedOption) {
//       case "url":
//         return (
//           <>
//             <Typography variant="body1">Enter a URL:</Typography>
//             <input
//               ref={inputRef} // Link the inputRef to the input field
//               type="text"
//               placeholder="https://example.com"
//               value={inputValue}
//               onChange={(e) => setInputValue(e.target.value)} // Handle input change
//               style={inputStyle}
//             />
//           </>
//         );
//       case "pdf":
//         return (
//           <>
//             <Typography variant="body1">Upload a PDF:</Typography>
//             <input
//               type="file"
//               accept=".pdf"
//               onChange={(e) => handleFileChange(e, "pdf")}
//               style={inputStyle}
//             />
//             <Typography variant="caption" sx={{ color: "gray", marginTop: "5px" }}>
//               Max file size: 50MB
//             </Typography>
//             {inputValue && inputValue.name && (
//               <Typography variant="body2" sx={{ marginTop: "10px", color: "green" }}>
//                 File Uploaded: {inputValue.name}
//               </Typography>
//             )}
//           </>
//         );
//       case "file":
//         return (
//           <>
//             <Typography variant="body1">Upload a File:</Typography>
//             <input
//               type="file"
//               onChange={(e) => handleFileChange(e, "file")}
//               style={inputStyle}
//             />
//             <Typography variant="caption" sx={{ color: "gray", marginTop: "5px" }}>
//               Max file size: 50MB
//             </Typography>
//             {inputValue && inputValue.name && (
//               <Typography variant="body2" sx={{ marginTop: "10px", color: "green" }}>
//                 File Uploaded: {inputValue.name}
//               </Typography>
//             )}
//           </>
//         );
//       case "images":
//         return (
//           <>
//             <Typography variant="body1">Upload an Image:</Typography>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) => handleFileChange(e, "image")}
//               style={inputStyle}
//             />
//             <Typography variant="caption" sx={{ color: "gray", marginTop: "5px" }}>
//               Max file size: 50MB
//             </Typography>
//             {inputValue && inputValue.name && (
//               <Typography variant="body2" sx={{ marginTop: "10px", color: "green" }}>
//                 File Uploaded: {inputValue.name}
//               </Typography>
//             )}
//           </>
//         );
//       case "videos":
//         return (
//           <>
//             <Typography variant="body1">Upload a Video:</Typography>
//             <input
//               type="file"
//               accept="video/*"
//               onChange={(e) => handleFileChange(e, "video")}
//               style={inputStyle}
//             />
//             {inputValue && inputValue.name && (
//               <Typography variant="body2" sx={{ marginTop: "10px", color: "green" }}>
//                 File Uploaded: {inputValue.name}
//               </Typography>
//             )}
//             <Typography variant="caption" sx={{ color: "gray", marginTop: "5px" }}>
//               Max file size: 50MB
//             </Typography>
//           </>
//         );
//       case "audio":
//         return (
//           <>
//             <Typography variant="body1">Upload an Audio:</Typography>
//             <input
//               type="file"
//               accept="audio/*"
//               onChange={(e) => handleFileChange(e, "audio")}
//               style={inputStyle}
//             />
//             {inputValue && inputValue.name && (
//               <Typography variant="body2" sx={{ marginTop: "10px", color: "green" }}>
//                 File Uploaded: {inputValue.name}
//               </Typography>
//             )}
//             <Typography variant="caption" sx={{ color: "gray", marginTop: "5px" }}>
//               Max file size: 50MB
//             </Typography>
//           </>
//         );
//       case "location":
//         return (
//           <>
//             <Typography variant="body1">Enter a Location URL:</Typography>
//             <input
//               ref={inputRef} // Link the inputRef to the input field
//               type="text"
//               placeholder="https://maps.google.com"
//               value={inputValue}
//               onChange={(e) => setInputValue(e.target.value)} // Handle input change
//               style={inputStyle}
//             />
//           </>
//         );

//         case "email":
//   return (
//     <>
//       <Typography variant="body1">* Email address</Typography>
//    <input
//    key="email"
//   ref={emailRef}
//   type="email"
//   placeholder="recipient@example.com"
//   value={inputValue.email || ""}
//  onChange={(e) => handleChange(e, 'email')}
//   onKeyDown={(e) => {
//     if (e.key === "Enter" && subjectRef.current) {
//       subjectRef.current.focus();
//     }
//   }}
//   required
//   style={inputStyle}
// />

// <input
//    key="subject"
//   ref={subjectRef}
//   type="text"
//   placeholder="Subject"
//   value={inputValue.subject || ""}
//  onChange={(e) => handleChange(e, 'subject')}
//   onKeyDown={(e) => {
//     if (e.key === "Enter" && bodyRef.current) {
//       bodyRef.current.focus();
//     }
//   }}
//   style={inputStyle}
// />

// <textarea
// key="body"
//   ref={bodyRef}
//   placeholder="Message"
//   value={inputValue.body || ""}
//  onChange={(e) => handleChange(e, 'body')}
//   style={{ ...inputStyle, height: "80px" }}
// />

//     </>
//   );

//       default:
//         return <Typography variant="body1">Please select an option</Typography>;
//     }
//   };
  
  const RenderInputField = ({ selectedOption }) => {
  const inputRef = useRef(null);
  const emailRef = useRef(null);
  const subjectRef = useRef(null);
  const bodyRef = useRef(null);
  const hasFocusedRef = useRef(false);

  const [inputValue, setInputValue] = useState("");

  // Reset value based on selected option
  useEffect(() => {
    hasFocusedRef.current = false; // Reset focus on option change

    switch (selectedOption) {
      case "phone":  setInputValue({
    phone: "",
        });
  break;
      case "contact":
  setInputValue({
    firstName: "",
    lastName: "",
    prefix: "",
    organization: "",
    jobTitle: "",
    email: "",
    phone: "",
    mobilePhone: "",
    fax: "",
    street: "",
    city: "",
    region: "",
    postcode: "",
    country: "",
    url: "",
  });
  break;

      case "email":
        setInputValue({ email: "", subject: "", body: "" });
        break;
      case "url":
      case "location":
        setInputValue("");
        break;
      case "pdf":
      case "file":
      case "images":
      case "videos":
      case "audio":
        setInputValue(null);
        break;
       
     
     
        default:
        setInputValue("");
    }
  }, [selectedOption]);

  // Focus handling
  useEffect(() => {
    if (!hasFocusedRef.current) {
      hasFocusedRef.current = true;
      if (selectedOption === "email") {
        emailRef.current?.focus();
      } else {
        inputRef.current?.focus();
      }
    }
  }, [selectedOption]);

  // Text field change handler for email fields
  const handleChange = (e, field) => {
    const { value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Generic file handler
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxFileSize = 50 * 1024 * 1024;
    if (file && file.size > maxFileSize) {
      alert("File is too large. Please select a file smaller than 50MB.");
    } else {
      setInputValue(file);
    }
  };

  switch (selectedOption) {
    case "url":
    case "location":
      return (
        <>
          <Typography variant="body1">
            {selectedOption === "url" ? "Enter a URL:" : "Enter a Location URL:"}
          </Typography>
          <input
            ref={inputRef}
            type="text"
            placeholder={
              selectedOption === "url" ? "https://example.com" : "https://maps.google.com"
            }
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            style={inputStyle}
          />
            {!isQrGenerated &&  ( <Box sx={{ marginTop: 4, textAlign: "right" }}>
        <Button variant="contained" color="primary" onClick={() => handleNextClick(inputValue)}>
          Next
        </Button>
      </Box>)}
        </>
      );

    case "pdf":
    case "file":
    case "images":
    case "videos":
    case "audio":
      const labelMap = {
        pdf: "Upload a PDF:",
        file: "Upload a File:",
        images: "Upload an Image:",
        videos: "Upload a Video:",
        audio: "Upload an Audio:",
      };

      const acceptMap = {
        pdf: ".pdf",
        images: "image/*",
        videos: "video/*",
        audio: "audio/*",
        file: "*",
      };

      return (
        <>
          <Typography variant="body1">{labelMap[selectedOption]}</Typography>
          <input
            type="file"
            accept={acceptMap[selectedOption]}
            onChange={handleFileChange}
            style={inputStyle}
          />
          <Typography variant="caption" sx={{ color: "gray", marginTop: "5px" }}>
            Max file size: 50MB
          </Typography>
          {inputValue && inputValue.name && (
            <Typography variant="body2" sx={{ marginTop: "10px", color: "green" }}>
              File Uploaded: {inputValue.name}
            </Typography>
          )}
            {!isQrGenerated &&  ( <Box sx={{ marginTop: 4, textAlign: "right" }}>
        <Button variant="contained" color="primary" onClick={() => handleNextClick(inputValue)}>
          Next
        </Button>
      </Box>)}
        </>
      );

    case "email":
      return (
        <>
          <Typography variant="body1">* Email address</Typography>
          <input
            key="email"
            ref={emailRef}
            type="email"
            placeholder="recipient@example.com"
            value={inputValue.email || ""}
            onChange={(e) => handleChange(e, "email")}
            onKeyDown={(e) => {
              if (e.key === "Enter" && subjectRef.current) {
                subjectRef.current.focus();
              }
            }}
            required
            style={inputStyle}
          />

          <input
            key="subject"
            ref={subjectRef}
            type="text"
            placeholder="Subject"
            value={inputValue.subject || ""}
            onChange={(e) => handleChange(e, "subject")}
            onKeyDown={(e) => {
              if (e.key === "Enter" && bodyRef.current) {
                bodyRef.current.focus();
              }
            }}
            style={inputStyle}
          />

          <textarea
            key="body"
            ref={bodyRef}
            placeholder="Message"
            value={inputValue.body || ""}
            onChange={(e) => handleChange(e, "body")}
            style={{ ...inputStyle, height: "80px" }}
          />
                {!isQrGenerated &&  ( <Box sx={{ marginTop: 4, textAlign: "right" }}>
        <Button variant="contained" color="primary" onClick={() => handleNextClick(inputValue)}>
          Next
        </Button>
      </Box>)}
        </>
      );
 
      case "contact":
  return (
    <>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Share contact details easily
      </Typography>
      <Typography variant="body2" sx={{ color: "gray", mb: 2 }}>
        * Indicates required field
      </Typography>

      {[
        { label: "First name", field: "firstName", required: true },
        { label: "Last name", field: "lastName" },
        { label: "Prefix", field: "prefix" },
        { label: "Organization", field: "organization" },
        { label: "Job title", field: "jobTitle" },
        { label: "Email", field: "email" },
        { label: "Phone", field: "phone" },
        { label: "Mobile phone", field: "mobilePhone" },
        { label: "Fax", field: "fax" },
        { label: "Street", field: "street" },
        { label: "City", field: "city" },
        { label: "Region", field: "region" },
        { label: "Postcode", field: "postcode" },
        { label: "Country", field: "country" },
        { label: "URL/Website/Social", field: "url" },
      ].map(({ label, field, required }) => (
        <input
          key={field}
          type="text"
          placeholder={label + (required ? " *" : "")}
          value={inputValue[field] || ""}
          onChange={(e) =>
            setInputValue((prev) => ({ ...prev, [field]: e.target.value }))
          }
          required={required}
          style={{ ...inputStyle, marginBottom: "10px" }}
        />
      ))}

     {!isQrGenerated &&  ( <Box sx={{ marginTop: 4, textAlign: "right" }}>
        <Button variant="contained" color="primary" onClick={() => handleNextClick(inputValue)}>
          Next
        </Button>
      </Box>)}
    </>
  );

 case "sms":
  return (
    <>
      <Typography variant="h6">📩 Link phone number to send a text message</Typography>
      <Typography variant="body2" sx={{ color: "gray", mb: 2 }}>
        * Indicates required field
      </Typography>

      <input
        type="tel"
        placeholder="Phone number *"
        value={inputValue.phone || ""}
        onChange={(e) => handleChange(e, "phone")}
        required
        style={{ ...inputStyle, marginBottom: "10px" }}
      />

      <textarea
        placeholder="Add message"
        value={inputValue.message || ""}
        onChange={(e) => handleChange(e, "message")}
        style={{ ...inputStyle, height: "80px" }}
      />
      
      {!isQrGenerated && (
        <Box sx={{ marginTop: 4, textAlign: "right" }}>
          <Button variant="contained" color="primary" onClick={() => handleNextClick(inputValue)}>
            Next
          </Button>
        </Box>
      )}
    </>
  );
case "phone":
  return (
    <>
      <Typography variant="h6">📞 Link a phone number for quick calls</Typography>
      <Typography variant="body2" sx={{ color: "gray", mb: 2 }}>
        * Indicates required field
      </Typography>

      <input
        type="tel"
        placeholder="Phone number *"
        value={inputValue.phone || ""}
        onChange={(e) => handleChange(e, "phone")}
        required
        style={{ ...inputStyle, marginBottom: "10px" }}
      />

      {!isQrGenerated && (
        <Box sx={{ marginTop: 4, textAlign: "right" }}>
          <Button variant="contained" color="primary" onClick={() => handleNextClick(inputValue)}>
            Next
          </Button>
        </Box>
      )}
    </>
  );

 
      default:
      return <Typography variant="body1">Please select an option</Typography>;
  }


  }

  const handleBack = () => {
    setIsQrGenerated(false); // Go back to dashboard (input fields) when Back is clicked
  };

  const [anchorEl, setAnchorEl] = useState(null);  // Manage the anchor element for the dropdown
  const navigate = useNavigate();

  // Handle click event for FaUser icon
  const handleUserClick = (event) => {
    setAnchorEl(event.currentTarget);  // Open the dropdown by setting the anchor element
  };

  // Close the dropdown menu
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Handle logout
  const handleLogout = () => {
    // Perform any logout logic if necessary
    navigate('/login');  // Navigate to the login page
    handleClose();  // Close the dropdown after logout
  };


  const handleSidebarItemClick = (item) => {
    console.log(item)
    setSelectedSidebarItem(item);
      // Close mobile sidebar on item click
  if (isMobile) {
    setMobileOpen(false);
  }

  };


  const renderDashboard = () => {
    switch (selectedSidebarItem) {
      case "Generate QR":
        return <DashboardComponent />;
      case "My QR Codes":
        return <QRCodeTable />;
      case "Profile":
        return <Profile />;
      case "Bulk Upload":
        return <BulkUpload />;
      case "Analytics":
        return <AnalyticsDashboard/>
      default:
        return <div>Select a valid option.</div>;
    }
  };



  const DashboardComponent = () => {
    return (
    <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
    <Toolbar />
    <Container   maxWidth="xl"
>
      {/* Buttons (Only Display When QR is not Generated) */}
      {!isQrGenerated && (
        <Grid container spacing={2} >
          {buttonOptions.map((btn) => (
            <Grid item xs={6} sm={6} md={2} key={btn.key}>
              <Button
                variant={selectedOption === btn.key ? "contained" : "outlined"}
                fullWidth
                onClick={() => handleButtonClick(btn.key)}
              >
                {btn.icon} {btn.label}
              </Button>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Dynamic Input Field */}
      <Box sx={{ marginTop: 3 }}>
      {isQrGenerated && (
         <div className="header-container d-flex flex-row align-items-center"  style={{
          marginTop: '2rem', /* Space from the top */
          padding: '20px', /* Padding inside the container */
          display: 'flex', /* Flexbox layout */
          alignItems: 'center', /* Center the items vertically */
         /* Space between items (Back button and title) */
          width: '100%', /* Full width of the container */
          flexWrap: 'wrap', /* Wrap the content on smaller screens */
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', /* Adding box shadow */
          borderRadius: '8px', /* Optional: rounded corners for better visual appeal */
        }}>
         {/* Back Button */}
         <Button
           variant="contained"
           color="secondary"
           onClick={handleBack} 
           className="back-button"
           
         >
           Back
         </Button>
   
         {/* Header and Subtext */}
         <div style={{marginLeft:50, textAlign:'center', color:"#0F172A" }} >
     
           <Typography  variant="h6" className="header-subtext">
             Customize your QR code with background color, foreground color, and logo.
           </Typography>
         </div>
       </div>
)}
       {!isQrGenerated ? (
  <RenderInputField
    selectedOption={selectedOption}
    inputValue={inputValue}
    setInputValue={setInputValue}
  />
) : (
  <QRCodeGenerator inputValue={qrInput} setInputValue={setQrInput} />
)}

      </Box>

      {/* Next Button */}

    </Container>
  </Box>
  )}

  return (
    <ThemeProvider theme={theme}>
 <Box
  component="main"
  sx={{
    flexGrow: 1,
    p: 2,
    width: {
      xs: "100%", // Full width on mobile
      sm: sidebarExpanded ? "calc(100% - 250px)" : "calc(100% - 80px)",
    },
    marginLeft: {
      xs: 0,
      sm: sidebarExpanded ? "250px" : "80px",
    },
    transition: "all 0.3s ease",
  }}
>

        <CssBaseline />

        {/* AppBar */}
        <AppBar
          position="fixed"
          sx={{
            width: isMobile ? "100%" : sidebarExpanded ? "80%" : "93%",
            flexShrink: 0,
            transition: "width 0.3s ease",
          }}
        >
          <Toolbar>
            {isMobile && (
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleMobileDrawerToggle}
                sx={{ mr: 2 }}
              >
                <FaBars />
              </IconButton>
            )}
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
            QR GENIOUS
            </Typography>
            <Button color="inherit" onClick={handleUserClick}>
        <FaUser />
      </Button>

      {/* Dropdown Menu for Logout */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}  // Open the menu if anchorEl is not null
        onClose={handleClose}  // Close the menu when clicking outside or on close button
      >
        <MenuItem onClick={handleLogout} style={{color:'red'}}>Logout</MenuItem>
      </Menu>
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            width: sidebarExpanded ? 250 : 80,
            flexShrink: 0,
            transition: "width 0.3s ease",
          }}
        >
          {/* Mobile Sidebar */}
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleMobileDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
               zIndex: 1300, 
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
            }}
          >
            {drawer}
          </Drawer>

          {/* Desktop Sidebar */}
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: sidebarExpanded ? 250 : 80,
                transition: "width 0.3s ease",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>

        {/* Main Content */}
  
        <Box component="main" sx={{ flexGrow: 1, p: 2 }}>
          <Toolbar />
          <Container >
            {/* Render Dashboard or QRCodeTable based on selectedSidebarItem */}
            {renderDashboard()}
          </Container>
        </Box>

      </Box>
    </ThemeProvider>
  );
};

// Input Field Style
const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "4px",
  border: "1px solid #ccc",
  marginTop: "10px",
};

export default Dashboard;
